import axios from 'axios';

import requestApiTimeouts from '../../consts/config/requestApiTimeouts';
import {log} from '../log';
import httpStatusTypesService from './httpStatusTypesService';

const get = (url, requestConfig) => requestApi('get', url, requestConfig);
const post = (url, requestConfig = {}) => requestApi('post', url, requestConfig);
const put = (url, requestConfig = {}) => requestApi('put', url, requestConfig);
const requestDelete = (url, requestConfig = {}) => requestApi('delete', url, requestConfig);

const requestApi = async (method, url, requestConfig = {}) => {
    let pendingTimeout;

    try {
        const controller = new AbortController();

        pendingTimeout = setTimeout(() => controller.abort(), requestApiTimeouts.PENDING_REQUEST_TIMEOUT);

        log.debug(`Request has started. Url: ${url}`);

        const response = await request({
            method,
            url,
            ...requestConfig,
            signal: controller.signal,
            timeout: requestApiTimeouts.PENDING_REQUEST_TIMEOUT,
        });

        clearTimeout(pendingTimeout);

        return response;
    } catch (e) {
        if (pendingTimeout) {
            clearTimeout(pendingTimeout);
        }

        const LOG_LENGTH_LIMIT = 10 * 1024;
        const requestConfigCopy = {...requestConfig};

        if (requestConfig?.headers) {
            const trimRequestConfigHeader = (headerName) => {
                const header = requestConfig.headers?.[headerName]?.toString();

                if (header) {
                    const NUMBER_OF_VISIBLE_CHARS = 10;
                    const headerTrimmed = `${header.substring(0, NUMBER_OF_VISIBLE_CHARS)}*****${header.substring(
                        header.length - NUMBER_OF_VISIBLE_CHARS
                    )}`;

                    requestConfigCopy.headers[headerName] = headerTrimmed;
                }
            };

            trimRequestConfigHeader('Authorization');
            trimRequestConfigHeader('Token');
            trimRequestConfigHeader('id_token');
            trimRequestConfigHeader('X-API-Key');
            trimRequestConfigHeader('jwt');
            trimRequestConfigHeader('et');
        }

        const logMessage = `requestApi: url: ${url}; requestConfig: ${JSON.stringify(
            requestConfigCopy
        )}, method: ${method}; error: ${e}; response data: ${JSON.stringify(e.response?.data)?.substring(
            0,
            LOG_LENGTH_LIMIT
        )}`;

        const statusCode = e?.response?.status;
        const isInfoLevel =
            httpStatusTypesService.isNotAuthorized(statusCode) || httpStatusTypesService.isNetworkError(statusCode);

        if (isInfoLevel) {
            log.info(logMessage);
        } else {
            log.error(logMessage);
        }

        throw e;
    }
};

const request = (requestConfig) => axios.request(requestConfig);

export default {
    get,
    post,
    put,
    requestDelete,
};
